export const enum SsrModule {
  HEADER = 'header',
  FOOTER = 'footer',
  STAGE_TABLE = 'stage_table',

  PREMATCH_TOURNAMENTS_TABLE = 'prematch_tournaments_table',
  PREMATCH_UNIONS_TABLE = 'prematch_unions_table',
  PREMATCH_SPORTS_TABLE = 'prematch_sports_grid',

  LEFT_MENU_HOMEPAGE = 'left_menu_homepage',
  LEFT_MENU_PREMATCH = 'left_menu_prematch',
  LEFT_MENU_LIVE = 'left_menu_live',
  LEFT_MENU_SERVICE = 'left_menu_service',

  MATCH_OF_THE_DAY = 'match_of_the_day',
  INTERESTING_MATCHES = 'interesting_matches',
  MINI_BANNERS = 'mini_banners',
  EXTERNAL_GAMES = 'external_games',
  MATCH_CENTER = 'match_center',
  MATCH_RESULT = 'match_result',
  SCOREBOARD = 'scoreboard',

  ACCOUNT = 'account',
  HISTORY = 'history',
  HISTORY_STAKES = 'history_stakes',
  ACTIVE_STAKES = 'active_stakes',
  WITHDRAWAL = 'withdrawal',
  DEPOSIT = 'deposit',
  NOTIFICATIONS = 'notifications',
  CASHBACK = 'cashback',
  PROMOTIONS = 'promotions',
  SETTINGS = 'settings',
}
